module.exports = __webpack_public_path__ + "assets/img/92854ae0dd7961e7be09f6e057b6fbc5.webp";